import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { contactRoute } from "constants/routes";
import images from "assets/images";
import { connect } from "react-redux";
import get from "lodash/get";

import { getPage } from "actions/page/page.functions";

import { PlatformSelector, SEO } from "components";

class Business extends PureComponent {
  state = {
    platform: undefined
  };

  componentDidMount(){
    const { dispatch } = this.props;
    
    let slug = "business";
    dispatch(getPage(slug));
  }

  handleUpdatePlatform = event => {
    const { platform } =
      event.currentTarget.dataset || event.srcElement.dataset;

    this.setState({ platform });
  };

  render() {
    const { platform } = this.state;
    const { singlePage } = this.props;

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    const platformSelectorProps = {
      platform,
      updatePlatformCallback: this.handleUpdatePlatform
    };

    return (
      <main className="view-business">
        <SEO {...seoProps} />
        <section className="view-business__splash">
          <div className="wrapper">
            <div className="view-business__splash__layout">
              <div className="view-business__splash__layout__visual">
                <img alt="Business" src={images.illustrationBusinessHeader} />
              </div>
              <div className="view-business__splash__layout__content">
                <h1 className="u-type--negative u-type--gamma u-spc-bottom--xlrg">
                  Biond White-label Communications solution for your business
                  needs
                </h1>
                <p className="u-type--zeta u-type--negative u-type--o50">
                  Share intra-organization ideas and strategy in secured medium
                  and at the same time downsize communications costs. Biond
                  White label is especially tailored to fit any company brand
                  image.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section section--primary view-business__internalcloud">
          <div className="wrapper">
            <div className="view-business__internalcloud__layout">
              <div className="view-business__internalcloud__layout__heading">
                <h3 className="u-type--gamma">
                  Internal cloud communication solution
                </h3>
              </div>
              <div className="view-business__internalcloud__layout__content">
                <p className="u-type--delta u-spc-bottom--lrg">
                  Embrace new business opportunities with the help of unique
                  platform designed for secure and private information
                  transmission.
                </p>
                <p className="u-type--zeta u-type--o50">
                  Cyber attacks, privacy breaches and lack of control over
                  organization's communications are serious threats in today's
                  global business environment. Biond addresses these challenges,
                  ensuring security and privacy, control, business productivity
                  and cost reduction to organization of any size.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="view-business__overview">
          <div className="view-business__overview__layout">
            <div className="wrapper">
              <div className="view-business__overview__layout__heading">
                <h3 className="u-type--delta u-type--o70">
                  Get an overview of all your messages, conversations and manage
                  your accounts.
                </h3>
              </div>
              <div className="view-business__overview__layout__content">
                <p className="u-type--zeta u-type--o50">
                  User friendly dashboard allows Admin to keep track of all
                  company history conversation.
                </p>
              </div>
            </div>
          </div>

          <div className="wrapper">
            <div className="view-business__overview__dashboard">
              <img alt="Biond Dashboard" src={images.biondDashboard} />
              <p className="view-business__overview__dashboard__notice u-type--o50">
                *Image displays testing results which are manipulated to show
                various functions of dashboard.
              </p>
            </div>
          </div>

          <div className="wrapper">
            <div className="view-business__overview__features">
              <div className="view-business__overview__features__item">
                <div className="u-spc-bottom--lrg">
                  <svg
                    width="62"
                    height="58"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      transform="translate(1 1)"
                      stroke="#F06F24"
                      strokeWidth="2"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M0 6v8c0 3.314 5.373 6 12 6s12-2.686 12-6V6" />
                      <path d="M0 14v8c0 3.314 5.373 6 12 6s12-2.686 12-6v-8" />
                      <path d="M0 22v8c0 3.314 5.373 6 12 6" />
                      <path d="M0 30v8c0 3.314 5.373 6 12 6" />
                      <ellipse cx="12" cy="6" rx="12" ry="6" />
                      <path d="M36 14v8c0 3.314 5.373 6 12 6s12-2.686 12-6v-8" />
                      <path d="M48 36c6.627 0 12-2.686 12-6v-8" />
                      <path d="M48 44c6.627 0 12-2.686 12-6v-8" />
                      <ellipse cx="48" cy="14" rx="12" ry="6" />
                      <path d="M18 34v8c0 3.314 5.373 6 12 6s12-2.686 12-6v-8" />
                      <path d="M18 42v8c0 3.314 5.373 6 12 6s12-2.686 12-6v-8" />
                      <ellipse cx="30" cy="34" rx="12" ry="6" />
                    </g>
                  </svg>
                </div>
                <h4 className="u-type--delta u-type--primary u-spc-bottom--lrg">
                  Balance tracking
                </h4>
                <p className="u-type--zeta u-type--o50">
                  Track balance of every user account and easily generate CDR
                  monhtly report
                </p>
              </div>
              <div className="view-business__overview__features__item">
                <div className="u-spc-bottom--lrg">
                  <svg
                    width="54"
                    height="62"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="#F06F24"
                      strokeWidth="2"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M1 1h52v60H1zM27 17h14" />
                      <path d="M13 17l2 2 6-6M27 31h14M13 31l2 2 6-6M27 45h14M13 45h4" />
                    </g>
                  </svg>
                </div>
                <h4 className="u-type--delta u-type--primary u-spc-bottom--lrg">
                  Choose your plan
                </h4>
                <p className="u-type--zeta u-type--o50">
                  Pre-paid or Post-paid payment method
                </p>
              </div>
              <div className="view-business__overview__features__item">
                <div className="u-spc-bottom--lrg">
                  <svg
                    width="62"
                    height="62"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="#F06F24"
                      strokeWidth="2"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M44.8 50.6C40.5 56.9 33.2 61 25 61 11.7 61 1 50.3 1 37s10.7-24 24-24" />
                      <path d="M54.7 57.4c4-5.8 6.3-12.8 6.3-20.4C61 17.1 44.9 1 25 1v36l29.7 20.4z" />
                    </g>
                  </svg>
                </div>
                <h4 className="u-type--delta u-type--primary u-spc-bottom--lrg">
                  Statistics
                </h4>
                <p className="u-type--zeta u-type--o50">
                  Simple behavior overview
                </p>
              </div>
              <div className="view-business__overview__features__item">
                <div className="u-spc-bottom--lrg">
                  <svg
                    width="54"
                    height="62"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="#F06F24"
                      strokeWidth="2"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M45 45V1H1v54a6 6 0 0 0 6 6" />
                      <path d="M13 55a6 6 0 0 1-6 6h40a6 6 0 0 0 6-6v-4H13v4zM11 15h24M11 26h24M11 37h24" />
                    </g>
                  </svg>
                </div>
                <h4 className="u-type--delta u-type--primary u-spc-bottom--lrg">
                  Detailed reporting
                </h4>
                <p className="u-type--zeta u-type--o50">
                  Detailed monthly reporting on Call, Instant Messaging and SMS
                  usage
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="view-business__benefits">
          <div className="view-business__benefits__heading">
            <div className="wrapper">
              <h2 className="u-type--gamma u-type--center">Benefits</h2>
            </div>
          </div>
          <ul className="view-business__benefits__list">
            <li className="view-business__benefits__item">
              <div className="u-spc-bottom--med">
                <svg width="32" height="30" xmlns="http://www.w3.org/2000/svg">
                  <g
                    stroke="#22363F"
                    strokeWidth="2"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M31 29H1V1h11l3 4h16z" />
                    <path d="M11 17h10v7H11zM13 17v-4a3 3 0 1 1 6 0v4" />
                  </g>
                </svg>
              </div>
              <h4 className="u-type--delta u-spc-bottom--lrg">Privacy</h4>
              <p className="u-type--zeta u-type--o50">
                Preserve your company know-how. Thanks to end-to-end encryption
                no one can enter your private messages, not even Biond team.
              </p>
            </li>

            <li className="view-business__benefits__item">
              <div className="u-spc-bottom--med">
                <svg width="22" height="32" xmlns="http://www.w3.org/2000/svg">
                  <g
                    stroke="#22363F"
                    strokeWidth="2"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M19 18v2a8 8 0 0 1-16 0v-2M1 18h20M11 31v-3M3 14V9a8 8 0 0 1 16 0v5" />
                  </g>
                </svg>
              </div>
              <h4 className="u-type--delta u-spc-bottom--lrg">
                Top calls quality
              </h4>
              <p className="u-type--zeta u-type--o50">
                Crystal clear On-net voice and video call quality. With Biond
                Out you can reach anyone around the world and at the same time
                cut your communications costs.
              </p>
            </li>

            <li className="view-business__benefits__item">
              <div className="u-spc-bottom--med">
                <svg width="32" height="30" xmlns="http://www.w3.org/2000/svg">
                  <g
                    stroke="#22363F"
                    strokeWidth="2"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="square"
                  >
                    <path d="M25 8h6v15h-4v5l-7-5h-6" />
                    <path d="M25 1H1v17h5v7l8-7h11z" />
                  </g>
                </svg>
              </div>
              <h4 className="u-type--delta u-spc-bottom--lrg">Messaging</h4>
              <p className="u-type--zeta u-type--o50">
                Choose real-time communication by single or group On-net
                chatting and file sharing or simply send SMS.
              </p>
            </li>

            <li className="view-business__benefits__item">
              <div className="u-spc-bottom--med">
                <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
                  <g
                    stroke="#22363F"
                    strokeWidth="2"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M15 29V1M2.489 15h25.022M15 1C11 4 5 6 1 6c0 9.333 4.667 19 14 23 9.333-4 14-13.667 14-23-4 0-10-2-14-5z" />
                  </g>
                </svg>
              </div>
              <h4 className="u-type--delta u-spc-bottom--lrg">Customization</h4>
              <p className="u-type--zeta u-type--o50">
                Completely customizable solution to adapt to your company brand
                image.
              </p>
            </li>
          </ul>
        </section>

        <section className="section section--primary u-type--center view-business__platforms">
          <div className="wrapper">
            <h3 className="u-type--gamma u-spc-bottom--xlrg">
              Support for all major platforms
            </h3>
            <p className="u-type--zeta u-spc-bottom--lrg">
              Biond App comes in all shapes and sizes. <br />
              Download Biond App for iOS, Android, macOS, Windows 10 and Linux.
            </p>
            <PlatformSelector {...platformSelectorProps} />
          </div>
        </section>

        <section className="section section--primary section--orange u-type--center">
          <div className="wrapper">
            <div className="view-business__reach-out">
              <h3 className="u-type--gamma u-type--negative u-spc-bottom--xlrg">
                Only Comunication Platform your business will ever need.
              </h3>
              <p className="u-type--negative u-type--o50 u-spc-bottom--lrg">
                For more info and support get in touch with a Biond support
                expert.
              </p>
              <Link
                to={contactRoute}
                className="btn btn--negative btn--med u-rounded"
              >
                Get in touch
              </Link>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { singlePage } = state.pages;

  return {
    singlePage
  };
};

export default connect(mapStateToProps)(Business);



// WEBPACK FOOTER //
// ./src/views/Business.jsx